<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
    w?: string;
    d?: string;
    t?: string;
    m?: string;
    ow?: string;
    od?: string;
    ot?: string;
    om?: string;
}>();

const classes = computed(() => {
    const classesByProps = {
        "col-wide-": props.w,
        "col-desktop-": props.d,
        "col-tablet-": props.t,
        "col-mobile-": props.m,
        "offset-wide-": props.ow,
        "offset-desktop-": props.od,
        "offset-tablet-": props.ot,
        "offset-mobile-": props.om,
    };
    const computedClasses = Object.entries(classesByProps)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}${value}`);
    return ["col", ...computedClasses].join(" ");
});
</script>

<template>
    <div :class="classes">
        <slot />
    </div>
</template>
